<template>
    <modal hide-footer hideHeader centered autoOpen classBody="p-0" contentClass="overflow-hidden"
           dialogStyle="max-width:686px">
        <template #default="{hide}">
            <div class="bg-banner d-flex flex-column">
                <button type="button" class="btn-close btn-close-white position-absolute" aria-label="Close"
                        @click="hide" style="top:30px;right: 30px; transform: scale(1.5); box-shadow: none !important;">
                </button>
                <div class="row mt-4">
                    <div class="col-12">
                        <div class="col-8 text-center mx-auto">
                             <p class="title text-uppercase">{{$t('banners.dolcepanino.title')}}</p>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="col-3 text-center mx-auto">
                            <img class="img-fluid" src="@/Content/images/banners/dolcePanino/logo.svg" />
                        </div>
                    </div>
                    <div class="col-12 text-center mx-auto">
                        <div class="col-8 text-center mx-auto mt-3">
                            <!-- <p class="subtitle mt-3 mb-0">{{$t('banners.preseason.vigencydays')}} | 06:20 P.M.</p> -->
                             <p class="subtitle mb-2">{{$t('banners.dolcepanino.content')}}</p>
                             <p class="toping-text">{{ $t('banners.dolcepanino.toppings') }} | {{ $t('banners.dolcepanino.from') }}</p>
                        </div>
                    </div>
                    <div class="col-12" style="position: absolute;bottom: 1.5rem !important;left: 0;right: 0;">
                        <div class="col-12 text-center mx-auto" style="border-color: white;border-top-style: solid;border-top-width: 1px;">
                            <p class="text-white fs-6 mt-2">{{$t('banners.dolcepanino.every')}} | <span class="schedule-text">{{ $t('banners.dolcepanino.schedule') }}</span></p>
                            <img src="@/Content/images/banners/dolcePanino/location.png" class="col-lg-4 col-md-4 col-sm-4 col-6" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>
<script>
import modal from '../modal.vue';
    export default {
        components: {
            modal
        }
    }
</script>
<style scoped>
    .title {
        font-family: 'Georgia';
        font-size: 52px;
        font-style: var(--unnamed-font-style-regular);
        font-weight: 300;
        line-height: var(--unnamed-line-spacing-43);
        letter-spacing: 2.4px;
        color:#b48215;
    }

    .subtitle {
        font-family: var(--unnamed-font-family-arpona);
        font-size: clamp(1rem, 1vw + 0.75rem, 1.563rem);
        font-style: var(--unnamed-font-style-italic);
        font-weight: var(--unnamed-font-weight-normal);
        letter-spacing: 0;
        color: #dbab41;
    }

    .toping-text{
        font-family: var(--unnamed-font-family-arpona);
        font-size: 16px;
        font-style: var(--unnamed-font-style-regular);
        font-weight: var(--unnamed-font-weight-normal);
        letter-spacing: 1px;
        color: #000000;
    }

    .schedule-text{
        font-family: var(--unnamed-font-family-arpona);
        font-size: 16px;
        font-style: var(--unnamed-font-style-regular);
        font-weight: var(--unnamed-font-weight-normal);
        letter-spacing: 1px;
        color: #dbab41;
    }
    .content-text {
        font-family: var(--unnamed-font-family-arpona);
        font-style: var(--unnamed-font-style-normal) normal 200;
        font-size: clamp(0.875rem, 2vw - 0.25rem, 1rem);
        color: var(--unnamed-color-ffffff);
        letter-spacing: 0px;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        pointer-events: auto;
        outline: 0;
    }

    .footer-content {
        position: absolute;
        bottom: 1.5rem !important;
        left: 0;
        right: 0;
        border-color:var(--unnamed-color-dbaa4b);
        border-top-style: dotted;
        border-right-style: none;
        border-bottom-style: dotted;
        border-left-style: none;
    }
    .bg-banner {
        position: relative;
        background: transparent linear-gradient(180deg, #11111DF2 0%, #11111D00 56%, #11111D00 100%) 0% 0% no-repeat padding-box;
        background-image: url('@/Content/images/banners/dolcePanino/bg.png');
        height: 611px;
        background-position: center;
        background-repeat: no-repeat !important;
        background-size: cover;
        border-radius: 45px;
        filter: brightness(0.9);
    }

    @media (max-width: 768px) {
        .bg-banner {
            position: relative;
            background: transparent linear-gradient(180deg, #11111DF2 0%, #11111D00 56%, #11111D00 100%) 0% 0% no-repeat padding-box;
            background-image: url('@/Content/images/banners/dolcePanino/bg.png');
            height: 611px;
            background-position: center;
            background-repeat: no-repeat !important;
            background-size: cover;
            border-radius: 45px;
            filter: brightness(0.9);
        }
    }

    @media (min-width: 769px) {
        .bg-banner {
            position: relative;
            background: transparent linear-gradient(180deg, #11111DF2 0%, #11111D00 56%, #11111D00 100%) 0% 0% no-repeat padding-box;
            background-image: url('@/Content/images/banners/dolcePanino/bg.png');
            height: 611px;
            background-position: center;
            background-repeat: no-repeat !important;
            background-size: cover;
            border-radius: 45px;
            filter: brightness(0.9);
        }
    }
</style>